<template>
    <div class="row" style="height:65vh">
        <div class="col-12 col-sm-6">
            <!-- <VirtualScroller :items="sitems" :itemSize="50" showLoader :loading="lazyLoading" :lazy=true @lazy-load="onLazyLoad">
                <template v-slot:item="{ item, options }">
                    <div :class="['scroll-item p-2', {'odd': options.odd}]" style="height: 50px">{{ item }}</div>
                </template>
                <template v-slot:loader="{ options }">
                    <div :class="['scroll-item p-2', {'odd': options.odd}]" style="height: 50px" >
                        <Skeleton :width="options.even ? '60%' : '50%'" height="1.3rem" />
                    </div>
                </template>
            </VirtualScroller>-->
            <Listbox
                v-model="selectedSItem"
                :options="sitems"
                :multiple="(pickOptions.source && pickOptions.source.multiple !== undefined) ? pickOptions.source.multiple : true"
                :filter="true"
                :filterPlaceholder="pickOptions.source && pickOptions.source.placeholder ? pickOptions.source.placeholder : ''"
                listStyle="max-height:53vh"
                style="height:100%"
                :optionLabel="pickOptions.source && pickOptions.source.optionLabel"
            >
                <!-- :virtualScrollerOptions="vso" -->
                <template #option="slotProps">
                    <div class="d-flex align-items-center">
                        <img
                            :src="slotProps.option.image"
                            class="float-start me-2 img-circle-cover"
                        />
                        <div>{{slotProps.option.product_code}}</div>
                        <div class="ms-auto">
                            <span v-if="slotProps.option.quantity" class="px-3">
                                <b>{{TR.product_balance}}:</b>
                                {{slotProps.option.quantity}}
                            </span>
                            <InputNumber
                                v-model="sitems_value[slotProps.option.id]"
                                :min="1"
                                :max="slotProps.option.quantity ? slotProps.option.quantity : ''"
                                class="tl-input"
                                @click.stop.prevent
                            />
                        </div>
                    </div>
                </template>
                <template #header>
                    <div
                        class="p-2 bg-light text-end border-bottom"
                    >{{pickOptions.source && pickOptions.source.footerText ? pickOptions.source.footerText : ''}} {{sitems.length}}</div>
                </template>
                <template v-slot:loader="{ options }">
                    {{options}}
                    <div :class="['scroll-item p-2', {'odd': options.odd}]" style="height: 50px">
                        <Skeleton :width="options.even ? '60%' : '50%'" height="1.3rem" />
                    </div>
                </template>
            </Listbox>
        </div>
        <div
            class="col-12 col-sm-1 w-auto d-flex1 flex-column1 align-self-center d-sm-grid gap-sm-3"
        >
            <!-- <Button icon="fas fa-angle-right" @click="sendSrc" /> -->
            <button class="btn btn-primary" @click="sendSrc"> <i class="fas fa-angle-right"></i> </button>
            <button class="btn btn-primary" @click="sendSrcAll"> <i class="fas fa-angle-double-right"></i> </button>
            <button class="btn btn-primary" @click="sendDest"> <i class="fas fa-angle-left"></i> </button>
            <button class="btn btn-primary" @click="sendDestAll"> <i class="fas fa-angle-double-left"></i> </button>
        </div>
        <div class="col-12 col-sm-5">
            <Listbox
                v-model="selectedDItem"
                :options="ditems"
                :multiple="(pickOptions.destination && pickOptions.destination.multiple !== undefined) ? pickOptions.destination.multiple : true"
                :filter="true"
                :filterPlaceholder="pickOptions.destination && pickOptions.destination.placeholder ? pickOptions.destination.placeholder : ''"
                listStyle="max-height:53vh"
                style="height:100%"
                :optionLabel="pickOptions.destination && pickOptions.destination.optionLabel"
            >
                <template #option="slotProps">
                    <div class="d-flex align-items-center">
                        <img
                            :src="slotProps.option.image"
                            class="float-start me-2 img-circle-cover"
                        />
                        <div>{{slotProps.option.product_code}}</div>
                        <div class="ms-auto">
                            <InputNumber
                                v-model="ditems_value[slotProps.option.id]"
                                :min="1"
                                :max="slotProps.option.quantity ? slotProps.option.quantity : ''"
                                class="tl-input"
                                @click.stop.prevent
                            />
                            <!-- @click.stop.prevent="" -->
                        </div>
                    </div>
                </template>
                <template #header>
                    <div
                        class="p-2 bg-light text-end border-bottom"
                    >{{pickOptions.destination && pickOptions.destination.footerText ? pickOptions.destination.footerText : ''}} {{ditems.length}}</div>
                </template>
            </Listbox>
        </div>
    </div>
</template>


<script>
    import { onUpdated, onUnmounted, ref, watchEffect } from "vue";

    import { useStore } from "@/store";

    // import Dropdown from "primevue/dropdown";
    // import Button from "primevue/button";
    import Listbox from "primevue/listbox";
    import InputNumber from "primevue/inputnumber";
    import Skeleton from "primevue/skeleton";
    // import VirtualScroller from "primevue/virtualscroller";

    import { useModelWrapper } from "@/utils/modelWrapper";

    export default {
        name: "TransferList",
        props: {
            source: Object,
            destination: Object,
            pickOptions: Object,
            mainref: Object,
        },
        // emits:["getData"],
        components: {
            // Dropdown,
            // Button,
            Listbox,
            InputNumber,
            Skeleton,
            // VirtualScroller,
        },
        setup(props, { emit }) {
            const store = useStore();

            const TR = ref(null);

            const PO = useModelWrapper(props, emit, "mainref");
            const sitems = useModelWrapper(props, emit, "source");
            const ditems = useModelWrapper(props, emit, "destination");

            // const sitems = ref([]);
            const sitems_value = ref([]);
            // const ditems = ref([]);
            const ditems_value = ref([]);

            const selectedSItem = ref([]);
            const selectedDItem = ref([]);

            // const scrollData = ref(0);
            const lazyLoading = ref(false);
            const vso = ref({
                // showLoader: true,
                // loading: lazyLoading.value,
                // itemSize: 50,
                // items: sitems.value,
                // lazy: false,
                // "lazy-load": onLazyLoad,
            });

            const onLazyLoad = () => {
                // const {first, last} = event;
                // console.log(first, last);
                // lazyLoading.value = true;
                // if( scrollData.value != first ){
                //     scrollData.value = scrollData.value + first;
                //     // sitems.value = props.source
                //     context.emit("getData", scrollData.value, last);
                // }
                // lazyLoading.value = false;
            };

            watchEffect(() => {
                TR.value = store.getTranslation();
                PO.value["titems"] = ditems.value;
                PO.value["titems_value"] = ditems_value.value;
            });

            onUpdated(() => {
                // if (props.source.length) {
                    sitems.value.forEach((e) => {
                        if( sitems_value.value[e.id] === undefined )
                            sitems_value.value[e.id] = 1;
                    });
                // }
                // if (props.destination.length) {
                    ditems.value.forEach((e) => {
                        if( ditems_value.value[e.id] === undefined )
                            ditems_value.value[e.id] = 1;
                    });
                // }
                // vso.value.items = sitems.value;
            });

            const sendSrc = () => {
                if (selectedSItem.value.length > 0) {
                    // ditems.value = ditems.value.concat(selectedSItem.value);
                    selectedSItem.value.forEach((e) => {
                        ditems.value.push(e);
                        ditems_value.value[e.id] = sitems_value.value[e.id];
                        sitems.value.forEach((a, i) => {
                            if (a.id == e.id) sitems.value.splice(i, 1);
                        });
                        if (!sitems.value.length) {
                            sitems.value = [];
                            sitems_value.value = [];
                        }
                    });
                    selectedSItem.value = [];
                }
            };
            const sendSrcAll = () => {
                if (sitems.value.length) {
                    // ditems.value = ditems.value.concat(sitems.value);
                    sitems.value.forEach((e) => {
                        ditems.value.push(e);
                        ditems_value.value[e.id] = sitems_value.value[e.id];
                        // sitems.value.splice(i, 1);
                    });
                    // ditems.value = sitems.value;
                    sitems.value = [];
                    sitems_value.value = [];
                    selectedSItem.value = [];
                }
            };

            const sendDest = () => {
                if (selectedDItem.value.length > 0) {
                    sitems.value = sitems.value.concat(selectedDItem.value);
                    selectedDItem.value.forEach((e) => {
                        sitems_value.value[e.id] = ditems_value.value[e.id];
                        delete ditems_value.value[e.id];
                        ditems.value.forEach((a, i) => {
                            if (a.id == e.id) ditems.value.splice(i, 1);
                        });
                    });
                    selectedDItem.value = [];
                }
            };
            const sendDestAll = () => {
                if (ditems.value.length) {
                    sitems.value = sitems.value.concat(ditems.value);
                    ditems.value.forEach((e) => {
                        sitems_value.value[e.id] = ditems_value.value[e.id];
                    });
                    // sitems.value = ditems.value;
                    ditems.value = [];
                    ditems_value.value = [];
                    selectedDItem.value = [];
                }
            };






            // watchEffect(() => {
            //     TR.value = store.getTranslation();
            //     props.source.forEach((e) => {
            //         sitems_value.value[e.id] = 1;
            //     });
            //     props.destination.forEach((e) => {
            //         ditems_value.value[e.id] = 1;
            //     });

            //     PO.value["titems"] = props.destination;
            //     PO.value["titems_value"] = ditems_value.value;
            // });

            // onMounted(() => {
            //     if (props.source.length) {
            //         // sitems.value = sitems.value.concat(props.source);
            //         // sitems.value = props.source;
            //         props.source.forEach((e) => {
            //             sitems_value.value[e.id] = 1;
            //         });
            //     }
            //     if (props.destination.length) {
            //         // ditems.value = props.destination;
            //         props.destination.forEach((e) => {
            //             ditems_value.value[e.id] = 1;
            //         });
            //     }
            //     // vso.value.items = sitems.value;
            // });


            onUnmounted(() => {
                sitems.value = [];
                sitems_value.value = [];
                ditems.value = [];
                ditems_value.value = [];
                selectedSItem.value = [];
                selectedDItem.value = [];
            });

            // const sendSrc = () => {
            //     if (selectedSItem.value.length > 0) {
            //         props.destination = props.destination.concat(selectedSItem.value);
            //         selectedSItem.value.forEach((e) => {
            //             ditems_value.value[e.id] = sitems_value.value[e.id];
            //             props.source.forEach((a, i) => {
            //                 if (a.id == e.id) props.source.splice(i, 1);
            //             });
            //             if (!props.source.length) {
            //                 // sitems.value = [];
            //                 sitems_value.value = [];
            //             }
            //         });
            //         selectedSItem.value = [];
            //     }
            // };
            // const sendSrcAll = () => {
            //     if (props.source.length) {
            //         props.destination = props.destination.concat(props.source);
            //         props.source.forEach((e) => {
            //             ditems_value.value[e.id] = sitems_value.value[e.id];
            //         });
            //         props.source = [];
            //         sitems_value.value = [];
            //         selectedSItem.value = [];
            //     }
            // };

            // const sendDest = () => {
            //     if (selectedDItem.value.length > 0) {
            //         props.source = props.source.concat(selectedDItem.value);
            //         selectedDItem.value.forEach((e) => {
            //             sitems_value.value[e.id] = ditems_value.value[e.id];
            //             delete ditems_value.value[e.id];
            //             props.destination.forEach((a, i) => {
            //                 if (a.id == e.id) props.destination.splice(i, 1);
            //             });
            //         });
            //         selectedDItem.value = [];
            //     }
            // };
            // const sendDestAll = () => {
            //     if (props.destination.length) {
            //         props.source = props.source.concat(props.destination);
            //         props.destination.forEach((e) => {
            //             sitems_value.value[e.id] = ditems_value.value[e.id];
            //         });
            //         // sitems.value = ditems.value;
            //         props.destination = [];
            //         ditems_value.value = [];
            //         selectedDItem.value = [];
            //     }
            // };

            return {
                TR,
                selectedSItem,
                selectedDItem,
                sitems,
                sitems_value,
                ditems,
                ditems_value,
                sendSrc,
                sendSrcAll,
                sendDest,
                sendDestAll,
                vso,
                lazyLoading,
                onLazyLoad,
            };
        },
    };
</script>


<style lang="scss">
    .p-listbox .p-listbox-list .p-listbox-item.p-highlight {
        color: #ffffff;
        background: var(--bs-primary);
    }
    .tl-input > input {
        margin-right: 10px;
        width: 80px;
    }
    .form-check-input:checked ~ .fci-div {
        color: #ffffff;
        background-color: var(--bs-primary);
    }
</style>
